<template>
    <v-container class="pa-6" fluid>
        <v-row justify="center" class="mb-0">
        <v-col cols="12" class="d-flex flex-column" md="12">
          <v-skeleton-loader
            type="card"
            :loading="dataLoading"
            class="flex d-flex flex-column"
          >
          <v-card elevation="0" style="background:transparent;">
            <v-card-title>
                Bonjour {{ user_data.profile.name.split(" ")[0] }} 👋
            </v-card-title>
            <v-card-subtitle>
                Nous sommes le 31 janvier 2025
            </v-card-subtitle>
            <v-alert
      prominent
      color="black"
      icon="mdi-star-circle"
      text
    
    >
      <v-row align="center">
        <v-col class="grow">
            <span class="font-weight-medium" style="font-size:16px">Vous avez une question ?</span>
            <br>
          <span style="font-size: 14px;">Nunc nonummy metus. Nunc interdum lacus sit amet orci. Nullam dictum felis eu pede mollis pretium. Cras id dui. Nunc nonummy metus. Nunc interdum lacus sit amet orci.</span>
        </v-col>
        <v-col class="shrink">
          <v-btn small>Take action</v-btn>
        </v-col>
      </v-row>
    </v-alert>
          </v-card>
        </v-skeleton-loader>
        </v-col>
        </v-row>
      <v-row justify="center" class="mb-0">
        <v-col cols="12" class="d-flex flex-column" md="12">
          <v-skeleton-loader
            type="card"
            :loading="dataLoading"
            class="flex d-flex flex-column"
          >
            <v-card class="flex d-flex flex-column dashboard-card px-4 py-4">
                <v-card-title>
                    Votre session de Février
                </v-card-title>
            
                <v-card-text class="py-4">
                   <v-row class="mb-1">
                    <v-progress-linear :value="20" rounded color="#FFCC01" height="8">

                    </v-progress-linear>
                   </v-row>
                   <v-row class="mb-0">
                    <v-col>
                        <v-divider vertical style="height:50px;border-color: rgba(0, 0, 0, 0.12);" ></v-divider>
                    </v-col>
                    <v-col>
                        <v-divider vertical style="height:50px;border-color: rgba(0, 0, 0, 0.12);" ></v-divider>
                    </v-col>
                    <v-col>
                        <v-divider vertical style="height:50px;border-color: rgba(0, 0, 0, 0.12);" ></v-divider>
                    </v-col>
                    <v-col>
                        <v-divider vertical style="height:50px;border-color: rgba(0, 0, 0, 0.12);" ></v-divider>
                    </v-col>
                   </v-row>
                   <v-row>
                    <v-col>
                       <v-list class="pt-0">
                        <v-list-item class="pl-0">
                            <v-list-item-icon class="mr-2">
                                <v-avatar class="elevation-1 pa-2">
                                    <div>
                                    <span class="font-weight-bold" style="font-size:16px">10</span>
                                    <br>
                                    <span style="color:#FCA24B;" class="caption">fev.</span>
                                </div>
                                </v-avatar>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium" style="font-size:14px">
                                    Kick off session
                                </v-list-item-title>

                                <v-list-item-subtitle>Secondary text</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                       </v-list>
                    </v-col>
                    <v-col>
                       <v-list class="pt-0">
                        <v-list-item class="pl-0">
                            <v-list-item-icon class="mr-2">
                                <v-avatar class="elevation-1 pa-2">
                                    <div>
                                    <span class="font-weight-bold" style="font-size:16px">10</span>
                                    <br>
                                    <span style="color:#FCA24B;" class="caption">fev.</span>
                                </div>
                                </v-avatar>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium" style="font-size:14px">
                                    Kick off session
                                </v-list-item-title>

                                <v-list-item-subtitle>Secondary text</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                       </v-list>
                    </v-col>
                    <v-col>
                       <v-list class="pt-0">
                        <v-list-item class="pl-0">
                            <v-list-item-icon class="mr-2">
                                <v-avatar class="elevation-1 pa-2">
                                    <div>
                                    <span class="font-weight-bold" style="font-size:16px">10</span>
                                    <br>
                                    <span style="color:#FCA24B;" class="caption">fev.</span>
                                </div>
                                </v-avatar>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium" style="font-size:14px">
                                    Kick off session
                                </v-list-item-title>

                                <v-list-item-subtitle>Secondary text</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                       </v-list>
                    </v-col>
                    <v-col>
                       <v-list class="pt-0">
                        <v-list-item class="pl-0">
                            <v-list-item-icon class="mr-2">
                                <v-avatar class="elevation-1 pa-2">
                                    <div>
                                    <span class="font-weight-bold" style="font-size:16px">10</span>
                                    <br>
                                    <span style="color:#FCA24B;" class="caption">fev.</span>
                                </div>
                                </v-avatar>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium" style="font-size:14px">
                                    Kick off session
                                </v-list-item-title>

                                <v-list-item-subtitle>Secondary text</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                       </v-list>
                    </v-col>
                   </v-row>
                </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col>
  
      </v-row>
  
  
    </v-container>
  </template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { db } from "@/firebase/init";

export default {
  name: "KickOff",
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      checked: true,
      autoPlaying: true,
      internalAutoPlaying: true,
      slides: [
        {
          title: "Slide #1",
          content: "Slide 1 content.",
        },
        {
          title: "Slide #2",
          content: "Slide 2 content.",
        },
      ],
      model: 0,
      barHeight: "18px",
      barMargin: "2px",
      e1: 0,
      dataLoaded: false,
      taskList: 0,
      dataLoading: true,
      headers: [
        {
          text: "Module",
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: "Progression",
          align: "start",
          sortable: false,
          value: "progress",
        },
        {
          text: "Actions",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],

      chartOptions: {
        colors: ["#2862FF"],
        chart: {
          height: 300,
          offsetY: -20,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 15,
              size: "70%",
            },
            startAngle: -90,
            endAngle: 90,
            track: {
              strokeWidth: "97%",
              background: "#E5EAFF",
              fillOpacity: 0.85,
              margin: 0,
            },
            dataLabels: {
              name: {
                show: true,
                color: "#88A6C9",
                fontSize: "14px",
                fontWeight: "500",
              },
              value: {
                fontSize: "20px",
                fontWeight: "600",
                show: true,
                offsetY: -37,
              },
            },
          },
        },
        labels: ["Mon avancée"],
        stroke: {
          lineCap: "round",
        },
      },
    };
  },
  computed: {
    ...mapState([
      "project",
      "user_data",
      "modules_v2",
      "progressModules",
      "coaches",
      "coach",
      "coachings",
      "tasks",
      "course",
      "webinars",
      "tickets",
      "userCourseInfo",
      "sessions",
      "userCourseDoc"
    ]),
    showBookMeetingBtn() {
  return !this.hasNoCoachingLeft &&
         this.currentSession.id !== '9JynXXNiyqKJbacC6CF3' &&
         this.currentSession.id !== '8xlUA5MhfuBQCFWnYhNB' &&
         !this.getNextEvent;
},
showCancellMeetingBtn() {
  return !this.hasNoCoachingLeft &&
         this.currentSession.id !== '9JynXXNiyqKJbacC6CF3' &&
         this.currentSession.id !== '8xlUA5MhfuBQCFWnYhNB' &&
         this.getNextEvent &&
         ((this.getNextEvent.status === 'scheduled') || 
         (this.getNextEvent.status === 'cancelled' && this.getNextEvent.isRescheduled === 'True'));
},
showRescheduleMeetingBtn() {
  return !this.hasNoCoachingLeft &&
         this.currentSession.id !== '9JynXXNiyqKJbacC6CF3' &&
         this.currentSession.id !== '8xlUA5MhfuBQCFWnYhNB' &&
         this.getNextEvent &&
         this.getNextEvent.status === 'cancelled' &&
         this.getNextEvent.isRescheduled === 'False';
},
    hasCancelledMeeting(calendlyEvents) {
           if (!calendlyEvents || calendlyEvents.length === 0) {
            return false;
        }
      const today = new Date().toISOString();
      const nextMeeting = calendlyEvents.find(event => new Date(event.date) > new Date(today));
      
      return nextMeeting && nextMeeting.status == 'cancelled';
    },
    isCancelled(meeting) {
    return meeting.status === 'cancelled';
  },
  hasFutureEvent(calendlyEvents) {
        if (!calendlyEvents || calendlyEvents.length === 0) {
            return false;
        }
        const now = new Date();
        const futureEvents = calendlyEvents.filter(event => {
            if (!event) return false;
            const eventDate = new Date(event.date);
            return event.status == 'scheduled' && eventDate > now;
        });
        return futureEvents.length > 0;
  },
getNextEventDate() {
let calendlyEvents = this.userCourseInfo.calendlyEvents;
  if (!calendlyEvents || calendlyEvents.length === 0) {
    return "-";
  }

  const nextEvent = this.getNextEvent;

  if (nextEvent && nextEvent.date) {
    return nextEvent.date
  } else {
    return "-";
  }
},
getNextEvent() {
  let calendlyEvents = this.userCourseInfo.calendlyEvents;
  if (!calendlyEvents || calendlyEvents.length === 0) {
    return null;
  }

  const now = new Date();

  // Filtrer les événements futurs
  const futureEvents = calendlyEvents.filter(event => new Date(event.date) > now);

  // Si aucun événement futur, retourner le dernier événement annulé non reprogrammé
  if (futureEvents.length === 0) {
    const lastCancelledEvent = calendlyEvents
      .filter(event => event.status === 'cancelled' && event.isRescheduled !== "True")
      .sort((a, b) => new Date(b.cancelledAt) - new Date(a.cancelledAt))[0];
    return lastCancelledEvent || null;
  }

  // Filtrer les événements planifiés qui n'ont pas d'annulation associée
  const futureScheduledEvents = futureEvents.filter(event => {
    if (event.status !== 'scheduled') return false;

    // Vérifier si cet événement a une annulation correspondante
    const correspondingCancelledEvent = calendlyEvents.find(cancelledEvent =>
      cancelledEvent.status === 'cancelled' &&
      cancelledEvent.eventId === event.eventId
    );

    // Inclure seulement s'il n'a pas d'annulation correspondante
    return !correspondingCancelledEvent;
  });

  // Retourner l'événement planifié le plus proche, s'il en existe un
  if (futureScheduledEvents.length > 0) {
    return futureScheduledEvents.sort((a, b) => new Date(a.date) - new Date(b.date))[0];
  }

  // Si aucun événement planifié n'existe, retourner le prochain événement annulé non reprogrammé
  const nextCancelledEvent = futureEvents.find(event => event.status === 'cancelled' && event.isRescheduled !== "True");
  return nextCancelledEvent || null;
},
    currentSession: function(){
      return this.sessions.find((session) => session.id === this.userCourseInfo.session_id)
    },
    tasksToDo: function () {
      return this.tasks.filter((task) => task.state === 1);
    },
    tasksDone: function () {
      return this.tasks.filter((task) => task.state === 3);
    },
    tasksDoing: function () {
      return this.tasks.filter((task) => task.state === 2);
    },
    lastCoachings: function () {
      return this.coachings
        .slice()
        .sort(
          (b, a) =>
            new Date(
              moment(a.date, "DD-MM-YYYY") -
                new Date(moment(b.date, "DD-MM-YYYY"))
            )
        );
    },
    recentWebinars: function () {
      return this.webinars.slice(0, 4);
    },
    series: function () {
      return [Math.round(this.averageProgress)];
    },
    currentModule: function () {
      let modulesNotWatched = [];
      let length = this.modules_v2.length - 1;

      this.modules_v2.forEach((modul, moduleIndex) => {
        if (this.moduleProgress(moduleIndex) != 100) {
          modulesNotWatched.push(modul);
        }
      });

      if (modulesNotWatched.length === 0) {
        return this.modules_v2[length];
      } else {
        return modulesNotWatched[0];
      }
    },
    currentModuleLessonsLength: function () {
      let length = 0;
      this.currentModule.chapters.forEach((chap) => {
        length += chap.lessons.length;
      });

      return length;
    },
    currentModuleLessonsDone: function () {
      let lessonsDone = [];
      this.progressModules
        .find((modul) => modul.id === this.currentModule.id)
        .chapters.forEach((chap) => {
          chap.lessons.forEach((less) => {
            if (less.done) {
              lessonsDone += less;
            }
          });
        });

      return lessonsDone.length;
    },
    blurBack: function () {
      if (this.user_data.project.selectedPackage === 0) {
        return "blur(8px)";
      } else {
        return "";
      }
    },
    justifiedRow() {
      if (this.user_data.project.selectedPackage != 4) {
        return "center";
      } else {
        return "start";
      }
    },
    averageProgress() {
      // let modules = this.modules_v2;
      // this.user_data.project.selectedPackage < 3 ? modules.pop() : modules;
      let numberOfModules = this.modules_v2.length;

      let averageModulesProgress = 0;

      this.modules_v2.forEach((modul, modulIndex) => {
        averageModulesProgress += this.moduleProgress(modulIndex);
      });

      return averageModulesProgress / numberOfModules;
    },
    templatesNotEmpty: function () {
      return !this.emptyRows;
    },
    calendlyURL: function () {
      if (this.hasNoCoachingLeft) {
        return `"${this.coach.agenda_premium}?hide_gdpr_banner=1"`;
      } else {
        return `"${this.coach.agenda}?hide_gdpr_banner=1"`;
      }
    },
    firstCallDone: function () {
      return this.coachings.find((coaching) => coaching.id === 0).date;
    },
    coachingsDone: function () {
      return this.coachings.filter((coaching) => coaching.done);
    },
    coachingsDoneNumber: function () {
      return this.coachingsDone.length;
    },
    coachingsDoneRate: function () {
      return (this.coachingsDoneNumber / this.maxCoachings) * 100;
    },
    maxCoachings: function () {
      let id = this.userCourseInfo.selectedPackage;
      let extraNum = parseInt(this.userCourseInfo.extraCoachings);

      if (id === 0 || id === 7 || id === 9 || id === 11 || id === 13 || id === 5) {
        return 0 + extraNum;
      } else if (id === 1 || id === 100) {
        return 4 + extraNum;
      } else if (id === 2 || id === 6) {
        return 6 + extraNum;
      } else if (id === 3 || id === 4 || id === 8 || id === 10 || id === 12 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20 || id === 21 || id === 22 || id === 23) {
        return 8 + extraNum;
      } else {
        return 0;
      }
    },
    hasNoCoachingLeft: function () {
      if (this.coachingsDoneNumber >= this.maxCoachings) {
        return true;
      } else {
        return false;
      }
    },
    lastCoachingDone: function () {
      let lastDate = new Date(
        Math.max.apply(
          null,
          this.coachingsDone
            .filter((coaching) => coaching.date && coaching.date != "")
            .map(function (e) {
              return new Date(moment(e.date, "DD-MM-YYYY"));
            })
        )
      );
      return lastDate;
    },
    nextCoaching: function () {
      let lastDate = new Date(
        Math.max.apply(
          null,
          this.coachingsDone
            .filter((coaching) => coaching.date && coaching.date != "")
            .map(function (e) {
              return new Date(moment(new Date(e.nextDate), "DD-MM-YYYY"));
            })
        )
      );
      return lastDate;
    },
    medalText: function () {
      if (Math.round(this.averageProgress) <= 50) {
        return "bronze";
      } else if (
        Math.round(this.averageProgress) > 50 &&
        Math.round(this.averageProgress) < 85
      ) {
        return "argent";
      } else {
        return "or";
      }
    },
    medalColor: function () {
      if (Math.round(this.averageProgress) <= 50) {
        return "#6D4C41";
      } else if (
        Math.round(this.averageProgress) > 50 &&
        Math.round(this.averageProgress) < 85
      ) {
        return "#9E9E9E";
      } else {
        return "#FFB300";
      }
    },
    nextMedalColor: function () {
      if (this.medalText === "bronze") {
        return "#9E9E9E";
      } else if (this.medalText === "argent") {
        return "#FFB300";
      } else {
        return "#FFB300";
      }
    },
    nextMedalValue: function () {
      if (this.medalText === "bronze") {
        return Math.round((Math.round(this.averageProgress) / 51) * 100);
      } else if (this.medalText === "argent") {
        return Math.round((Math.round(this.averageProgress) / 86) * 100);
      } else {
        return Math.round((Math.round(this.averageProgress) / 100) * 100);
      }
    },
    nextMedalInt: function () {
      if (this.medalText === "bronze") {
        return 51 - Math.round(this.averageProgress);
      } else if (this.medalText === "argent") {
        return 86 - Math.round(this.averageProgress);
      } else {
        return 100 - Math.round(this.averageProgress);
      }
    },
    learningDone: function () {
      let pad = function (num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
      };
      let time = 0;
      this.modules_v2.forEach((modul, index) => {
        time += (this.moduleProgress(index) / 100) * modul.minutes;
      });

      if (Math.round(time) < 60) {
        return `${Math.round(time)} min`;
      } else {
        let num = Math.round(time);
        let hours = num / 60;
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);
        return rhours + "h" + pad(rminutes, 2);
      }
    },
  },
  methods: {
    formatDateTime(date) {
    if (!date) {
        return "-";
    }
    date = new Date(date);
    return date.toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,  // Format 24 heures
        timeZone: 'Europe/Paris'  // Spécifie le fuseau horaire si nécessaire
    });
},
    getWebinarIcon(id) {
      if (id === 1) {
        return "mdi-magnify";
      } else if (id === 2) {
        return "mdi-bullhorn";
      } else if (id === 4) {
        return "mdi-code-tags";
      } else if (id === 0) {
        return "mdi-comment-outline";
      }
      else if (id === 3) {
        return "mdi-briefcase";
      }
    },
    updateTasks(id, bool) {
      this.$store
        .dispatch("updateTasks", {
          id: id,
          done: bool,
          course: this.$route.params.course,
        })
        .then(() => {
          if (bool) {
            this.snackbarText =
              "Félicitations ! Vous venez de terminer une tâche de plus 🎉";
            this.snackbar = true;
          } else {
            this.snackbarText =
              "Vous venez de marquer cette tâche comme non terminée, au travail 🤓";
            this.snackbar = true;
          }
        });
    },
    slideTitle(index) {
      return `Coaching n°${index + 1}`;
    },
    createTasksCollection() {
      this.tasks.forEach((task, index) => {
        db.collection(
          `users/${this.user_data.profile.user_id}/courses/${this.$route.params.course}/tasks`
        )
          .doc()
          .set({
            checklist: task.checklist,
            subtitle: task.subtitle,
            title: task.title,
            index: index,
          });
      });
    },
    numberOfDaysAgo(date) {
      if (!date) {
        return null;
      }
      let today = moment();
      let formatedDate = new Date(moment(date, "DD-MM-YYYY"));
      return today.diff(formatedDate, "days");
    },
    dateColor(date) {
      let today = new Date();
      let formatedDate = new Date(moment(date, "DD-MM-YYYY"));
      if (this.coachings.length === 0 || !date) {
        return "grey";
      }
      if (formatedDate <= moment(today).subtract(1, "month")) {
        return "error";
      } else if (formatedDate <= moment(today).subtract(14, "days")) {
        return "#ffd600";
      } else {
        return "blue accent-4";
      }
    },
    barColor(id) {
      if (this.coachingsDone.some((coaching) => coaching.id === id)) {
        return "#2862FF";
      } else {
        return "#C1D1FF";
      }
    },
    barColor_2(id) {
      if (this.coachingsDone.some((coaching) => coaching.id === id)) {
        return "#2862FF";
      } else {
        return "#C1D1FF";
      }
    },
    resumeModule(moduleIndex) {
      let unSeenLessons = [];
      if (
        this.moduleProgress(moduleIndex) === 0 ||
        this.moduleProgress(moduleIndex) === 100
      ) {
        this.$router.push({
          path: `/academie/course/${this.$route.params.course}/${
            moduleIndex + 1
          }/1/1`,
        });
      } else {
        this.modules_v2[moduleIndex].chapters.forEach((chapter, chapIndex) => {
          chapter.lessons.forEach((less, lessIndex) => {
            if (
              !this.progressModules[moduleIndex][`chapter_${chapIndex + 1}`][
                `lesson_${lessIndex + 1}`
              ]
            ) {
              unSeenLessons.push({
                chapPath: chapIndex + 1,
                lessPath: lessIndex + 1,
              });
            }
          });
        });

        this.$router.push({
          path: `/academie/course/${this.$route.params.course}/${
            moduleIndex + 1
          }/${unSeenLessons[0].chapPath}/${unSeenLessons[0].lessPath}`,
        });
      }
    },
    numberOfLessons(modul) {
      let lessons = 0;
      modul.chapters.forEach((chap) => {
        lessons += chap.lessons.length;
      });
      return lessons;
    },
    log(i) {
      console.log(i);
    },
    uncompleteLesson(modul, chap, less) {
      return !this.progressModules[modul][`chapter_${chap + 1}`][
        `lesson_${less + 1}`
      ];
    },
        numberOfLessonsCompleted(modul, chap, lessons) {
      let arr = [];

      lessons.forEach((less, index) => {
        if (this.completedLesson(modul, chap, index)) {
          arr.push(less);
        }
      });

      return arr.length;
    },
      completedLesson: function (modul, chap, less) {
      return this.progressModules[modul][`chapter_${chap + 1}`][
        `lesson_${less + 1}`
      ];
    },
    chapterProgress(modul, chap) {
      if(this.modules_v2.length > 0){

     
      let chapterLength = this.modules_v2[modul].chapters[chap].lessons.length;
      let lessonsCompleted = 0;

      if (this.progressModules[modul]) {
        // Object.keys(this.progressModules[modul][`chapter_${chap + 1}`]).forEach(
        //   (lesson) => {
        //     let lessonIndex = parseInt(lesson.slice(-1)) - 1;

        //     if (!this.uncompleteLesson(modul, chap, lessonIndex)) {
        //       lessonsCompleted++;
        //     }
        //   }
        // );

         lessonsCompleted = this.numberOfLessonsCompleted(modul, chap, this.modules_v2[modul].chapters[chap].lessons)

        return parseFloat((lessonsCompleted / chapterLength) * 100);
      }
       }
    },
    moduleProgress(index) {
      let moduleLength = this.modules_v2[index].chapters.length;
      let averageProgress = 0;

      this.modules_v2[index].chapters.forEach((chapter, chapIndex) => {
        averageProgress += this.chapterProgress(index, chapIndex);
      });

      return averageProgress / moduleLength;
    },
  },
  async mounted() {
    await this.$store.dispatch("setUserData");
    await this.$store.dispatch("setCourse", this.$route.params.course);
    await this.$store.dispatch("setCoaches");
    await this.$store.dispatch("setUserCourseInfo", this.$route.params.course);
    await this.$store.dispatch("setUserCourseDoc", this.$route.params.course);
    await this.$store.dispatch("setCoach", this.userCourseInfo.coach);
    await this.$store.dispatch("setModulesV2", this.$route.params.course);
    await this.$store.dispatch("setProgressModules", this.$route.params.course);
    await this.$store.dispatch("setTasks", this.$route.params.course);
    await this.$store.dispatch("setCoachings", this.$route.params.course);
    await this.$store.dispatch("setWebinars");
    await this.$store.dispatch("setTickets");
        await this.$store.dispatch("setSessions", this.$route.params.course);
    await this.$store.dispatch("updateStaticGlobalProgress", {
      course: this.$route.params.course,
      progress: Math.round(this.averageProgress),
    });
         this.dataLoaded = true;
    setTimeout(() => {
      this.dataLoading = false;
    }, 1400);
  },
};
</script>